import {DashboardPagesEnum} from "../Enums/DashboardPagesEnum";

export const formatNumberWithSeparator = (number, separator) => {
    if (typeof number !== 'number') {
        return 'Invalid input';
    }

    let numberString = number.toString();

    const regex = /\B(?=(\d{3})+(?!\d))/g;
    numberString = numberString.replace(regex, separator);

    return numberString;
}

export const isExpired = (seconds) => {
    const targetDate = Date.now() + seconds * 1000;
    return targetDate < Date.now();
}

export const gotoLoginPage = () => {
    window.location = '/login';
}

export const saveEmailToLocalStorage = (email) => {
    saveToLocalStorage('CARZELLE_LOGIN_EMAIL', email);
}

export const Logout = () => {
    deleteCookie('CARZELLE_API_TOKEN');
    let saveLoginEmail = localStorage.getItem('CARZELLE_LOGIN_EMAIL');
    localStorage.clear();
    saveEmailToLocalStorage(saveLoginEmail);
}

// function friendly date takes date as an argument an returns number of hours if the date is today and days if the date is less than thirty days and then months if the date is less than a year and then years
export const friendlyDate = (date) => {
    const now = new Date();
    const diff = now - new Date(date);
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    if (seconds < 60) {
        return `${seconds} seconds`;
    } else if (minutes < 60) {
        return `${minutes} minutes`;
    } else if (hours < 24) {
        return `${hours} hours`;
    } else if (days < 30) {
        return `${days} days`;
    } else if (months < 12) {
        return `${months} months`;
    } else {
        return `${years} years`;
    }
}


export const UnprotectedPage = () => {
    let currentPath = (window.location.pathname).toLowerCase();

    let unprotectedPaths = process.env.REACT_APP_UNPROTECTED_PATHS.split(',');
    return unprotectedPaths.includes(currentPath);
}

export const getFirstXCharacters = (string, x) => {
    if (typeof string !== 'string') {
        return 'Invalid input';
    }

    return string.substring(0, x);
}

export const valueIfNull = (value, defaultValue) => {
    if (value === undefined || value === null) {
        return defaultValue;
    }
    return value;
}

// function that takes a number and returns a string. If the number is below 10 then put a 0 in front of it
export const formatNumberWithLeadingZero = (number) => {
    if (typeof number !== 'number') {
        return 'Invalid input';
    }

    return number < 10 ? `0${number}` : number.toString();
}

export const isEmail = (email) => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    return regex.test(email);
};

export const setCookie = (name, value, daysToExpire) => {
    const date = new Date();
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
}

export const getCookie = (name) => {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null; // Cookie not found
}

export const deleteCookie = (name) => {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export const saveToLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
}

export const getFromLocalStorage = (key) => {
    return localStorage.getItem(key);
}

export const EnsureNoneBreakingSpace = (text) => {
    return text.replace(/ /g, '\u00a0');
}

export const getFormattedDate = (date, separator) => {
    const day = formatNumberWithLeadingZero(date.getDate());
    const month = formatNumberWithLeadingZero(date.getMonth() + 1);
    const year = date.getFullYear();

    return `${day}${separator}${month}${separator}${year}`;
}

export const getDayOfMonth = (date) => {
    return date.split('-')[0];
}

export const getMonth = (date) => {
    return date.split('-')[1];
}

export const getYear = (date) => {
    return date.split('-')[2];
}

export const getTwoDigitYear = (date) => {
    return date === '' ? '' : date.split('-')[2].substring(2);
}

export const formatIntegerNumberWithThousandSeparator = (number) => {
    let result = Number(number);
    result = Math.floor(result);

    result = Intl.NumberFormat('da-DK').format(result);

    return result;
}

export const getMonthName = (date) => {
    const month = getMonth(date);
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return monthNames[month - 1];
}

export const getMonthShortName = (date) => {
    const month = getMonth(date);
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return monthNames[month - 1];
}

export const scrollToId = (bookmarkName) => {
    const element = document.getElementById(bookmarkName);
    if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
}

export const DeleteUrlParameter = (parameterName) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(parameterName);
    window.history.replaceState({}, '', url);
}

// Function for smooth scroll animation with the time duration
export const easeInOutQuad = (time, startPos, endPos, duration) => {
    time /= duration / 2;

    if (time < 1) return (endPos / 2) * time * time + startPos;
    time--;
    return (-endPos / 2) * (time * (time - 2) - 1) + startPos;
}

export const scrollTo = (element, to, duration) => {
    let start = element.scrollTop,
        currentTime = 0,
        increment = 20;

    let animateScroll = function () {
        currentTime += increment;

        let val = easeInOutQuad(currentTime, start, to, duration);
        element.scrollTop = val;

        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };

    animateScroll();
}

// This is the main function where which pass two ref parameters of Parent element & Child element
export const scrollIntoViewUniversal = (parent, child) => {
    const parentBounding = parent.getBoundingClientRect(),
        clientBounding = child.getBoundingClientRect();

    const parentBottom = parentBounding.bottom,
        parentTop = parentBounding.top,
        clientBottom = clientBounding.bottom,
        clientTop = clientBounding.top;

    if (parentTop >= clientTop) {
        scrollTo(parent, -(parentTop - clientTop), 300);
    } else if (clientBottom > parentBottom) {
        scrollTo(parent, clientBottom - parentBottom, 300);
    }
};

// Get the value of the query parameter from the URL and return a specified value if it is not found
export const getUrlParameter = (name, defaultValue) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name) || defaultValue;
}

export const RemoveNoneNumberCharacters = (text) => {
    return text.replace(/\D/g, '');
}

export const findMinMaxPrices = (cars) => {
    if (cars.length === 0) {
        return {minPrice: 0, maxPrice: 0}; // Return default values for empty array
    }

    const {minPrice, maxPrice} = cars.reduce(
        (acc, car) => {
            return {
                minPrice: Math.min(acc.minPrice, car.price),
                maxPrice: Math.max(acc.maxPrice, car.price)
            };
        },
        {minPrice: Infinity, maxPrice: -Infinity}
    );

    return {minPrice, maxPrice};
};

export const findMinMaxKm = (cars) => {
    if (cars.length === 0) {
        return {minKm: 0, maxKm: 0}; // Return default values for empty array
    }

    const {minKm, maxKm} = cars.reduce(
        (acc, car) => {
            return {
                minKm: Math.min(acc.minKm, car.km),
                maxKm: Math.max(acc.maxKm, car.km)
            };
        },
        {minKm: Infinity, maxKm: -Infinity}
    );

    return {minKm, maxKm};
};

export const findMinMaxDamageAmount = (cars) => {
    if (cars.length === 0) {
        return {minDamageAmount: 0, maxDamageAmount: 0}; // Return default values for empty array
    }

    const {minDamageAmount, maxDamageAmount} = cars.reduce(
        (acc, car) => {
            return {
                minDamageAmount: Math.min(acc.minDamageAmount, car.damage_amount),
                maxDamageAmount: Math.max(acc.maxDamageAmount, car.damage_amount)
            };
        },
        {minDamageAmount: Infinity, maxDamageAmount: -Infinity}
    );

    return {minDamageAmount, maxDamageAmount};
};

export const getDefaultStartPath = () => {
    // Detect if the device is mobile and set the default path accordingly
    const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
    const userAgent = navigator.userAgent || window.opera;
    const isMobileDevice = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    const isMobile = isSmallScreen || isMobileDevice;
    const path = isMobile ? "mobile" : "dashboard/" + DashboardPagesEnum.carlist;
    return path;
}